import { z } from "zod";

export const schemaDefaults = <Schema extends z.ZodFirstPartySchemaTypes>(schema: Schema): z.TypeOf<Schema> => {
    switch (schema._def.typeName) {
        case z.ZodFirstPartyTypeKind.ZodDefault:
            return schema._def.defaultValue();
        case z.ZodFirstPartyTypeKind.ZodObject: {
            // The switch wasn't able to infer this but the cast should  be safe.
            return Object.fromEntries(Object.entries((schema as z.SomeZodObject).shape).map(([key, value]) => [key, schemaDefaults(value)]));
        }
        case z.ZodFirstPartyTypeKind.ZodEffects: {
            // Handle refined schemas by recursing into the inner schema
            return schemaDefaults((schema as z.ZodEffects<z.ZodTypeAny>)._def.schema);
        }
        case z.ZodFirstPartyTypeKind.ZodOptional: {
            return undefined;
        }
        case z.ZodFirstPartyTypeKind.ZodBoolean:
            return false;
        case z.ZodFirstPartyTypeKind.ZodArray:
            return [];
        case z.ZodFirstPartyTypeKind.ZodString:
            return "";
        case z.ZodFirstPartyTypeKind.ZodNumber:
            return 0;
        case z.ZodFirstPartyTypeKind.ZodNull:
            return null;
        case z.ZodFirstPartyTypeKind.ZodNullable:
            return null;
        case z.ZodFirstPartyTypeKind.ZodUndefined:
            return undefined;
        // etc
        default:
            throw new Error(`Unsupported type ${schema._type}`);
    }
};
